import { useTranslation } from 'react-i18next';
import { Instagram, Twitter, Music2 } from 'lucide-react';
import styles from './Footer.module.css';

function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.topLine} />

      <div className={styles.container}>
        <div className={styles.symbol}>⌖</div>

        <p className={styles.greeting}>
          {t('footer.greetingStart', { defaultValue: 'Oi!' })}
          {t('footer.greetingBody', { defaultValue: ' criei este site como um tributo ao mistério, à estética e à intensidade que o Sleep Token transmite. Espero que você sinta um pouco dessa atmosfera por aqui.' })}
          <br />
          {t('footer.moreIntro', { defaultValue: 'Conheça um pouco mais do meu trabalho ' })}
          <a href="https://evelynporto.dev" target="_blank" rel="noreferrer" className={styles.moreLink}>{t('footer.moreLinkText', { defaultValue: 'clicando aqui' })}</a>
        </p>

        <div className={styles.socials}>
          <a href="https://www.instagram.com/sleep_token" target="_blank" rel="noreferrer noopener" className={styles.socialBtn} aria-label="Instagram">
            <Instagram size={16} />
          </a>
          <a href="https://x.com/Sleep_Token" target="_blank" rel="noreferrer noopener" className={styles.socialBtn} aria-label="Twitter">
            <Twitter size={16} />
          </a>
          <a href="https://sleeptoken.lnk.to/EvenInArcadia/spotify" target="_blank" rel="noreferrer noopener" className={styles.socialBtn} aria-label="Spotify">
            <Music2 size={16} />
          </a>
        </div>
      </div>

      <div className={styles.copy}>
        {t('footer.copy', { year, defaultValue: '© {{year}} Sleep Token Fan Site' })}
      </div>
    </footer>
  );
}

export default Footer;